/* eslint-disable */
// ========= IMPORTS - AUTHENTICATION =========
import Login from "../pages/Login/Login";
import Register from "../pages/Register/Register";
import ForgotPassword from "../pages/Login/ForgotPassword";
import Logout from "../pages/Login/Logout";

// ========= IMPORTS - DASHBOARDS =========
import GlobalDashboard from "../pages/Dashboard/GlobalDashboard";
import DoctorManagementDashboard from "../pages/Dashboard/DoctorManagementDashboard";
import ProcurementDashboard from "../pages/Dashboard/ProcurementDashboard";

// ========= IMPORTS - DOCTOR MANAGEMENT =========
import DoctorDashboard from "../pages/DoctorManagement/Doctor/DoctorDashboard";
import PrescriptionList from "../components/PrescriptionManagement/List/PrescriptionList";
import PatientTable from "../components/Patient/list/PatientTable";
import TreatmentsList from "../components/TreatmentTemplateManagement/TreatmentsList";
import HealthCenters from "../pages/DoctorManagement/HealthCenters/HealthCenters";
import InventoryTable from "../components/InventoryManagement/List/InventoryTable";
import MedicinesList from "../components/MedicineComponent/MedicinesList";
import Treatments from "../pages/DoctorManagement/Treatment/Treatments";
import PatientTreatments from "../components/treatments/PatientTreatments";
import VaccinationList from "../components/VaccinationManagement/List/VaccinationList";
import AppointmentTimelineList from "../components/AppointmentTimeline/List/appointmentTimelineList";
import PatientTreatmentsDetail from "../components/PatientTreatmentDetails/List/PatientTreatmentDetailList"; // Assuming this is the correct import for PatientTreatmentDetailList
import BillingList from "../components/BillableActivities/List/BillingList";

// ======= IMPORTS PATIENT VIEW =======
import PatientView from "../components/PerfilPatientView/List/PatientView";
import AllergiesTreatments from "../components/PerfilPatientView/PatientManagementView/Components/AllergiesComponent/AllergiesTreatments";
import ImmunizationTreatments from "../components/PerfilPatientView/PatientManagementView/Components/ImmunizationTreatment/ImmunizationTreatment";
import VitalsTreatments from "../components/PerfilPatientView/PatientManagementView/Components/HealthLogTreatment/VitalsTreatment";
import ElectronicPrescriptionsTreatments from "../components/PerfilPatientView/PatientManagementView/Components/ElectronicPrescriptionTreatment/ElectronicPrescriptionsTreatment";
import AppointmentTreatment from "../components/PerfilPatientView/PatientManagementView/Components/AppointmentTreatment/AppointmentTreatment";
import ConditionsTreatment from "../components/PerfilPatientView/PatientManagementView/Components/ConditionsTreatment/ConditionsTreatment";
import MedicineTreatment from "../components/PerfilPatientView/PatientManagementView/Components/MedicineTreatment/MedicineTreatment";
import ResultTreatment from "../components/PerfilPatientView/PatientManagementView/Components/ResultTreatment/ResultTreatment";
import OrdersTreatment from "../components/PerfilPatientView/PatientManagementView/Components/OrdersTreatment/OrdersTreatment";
import ConsentTreatment from "components/PerfilPatientView/PatientManagementView/Components/ConsentTreatment/ConsentTreatment";

// ========= IMPORTS - TOOLS =========
import SmartList from "../components/SmartTranslator/List/SmartList";
import DiagnosticAssistantList from "../components/DiagnosticAssistant/List/DiagnosticAssistantList";
import InteractionVisualizer from "../pages/Visualizer/InteractionVisualizer";
import ElectronicPrescription from "../components/ElectronicPrescription/ElectronicPrescription";
import SymptomAssistant from "../components/SymptomAssistant/SymptomAssistant";
import DigimevoPrescription from "../pages/DoctorManagement/digimevo/Digimevo/DigimevoPresciption";
import CogniEvaManage from "../pages/DoctorManagement/CogniEva/CogniEvaManage";
import CompanyProcessManage from "../pages/DoctorManagement/CompanyProcess/CompanyProcessManage";

// ========= IMPORTS - ADMINISTRATION =========
import Treatment from "../components/TreatmentTemplateManagement/Treatment";
import PatientPrescriptionTreatments from "../components/PerfilPatientView/PatientManagementView/Components/PatientPrescriptions/PatientPrescriptionTreatments";
import ProductView from "../components/ProductCatalog/ProductsView/ProductView";
import CustomerPriceList from "components/ProductCatalog/CustomerPriceList/CustomerPriceList";
import SupplierPriceList from "components/ProductCatalog/SupplierPriceList/SupplierPriceList";
import LaboratoryTemplates from "components/LabTemplates/LaboratoryTemplates/LaboratoryTemplates";
import LaboratoryTemplateAdd from "components/LabTemplates/LaboratoryTemplates/laboratoryTemplateAdd";
import DashboardGlobal from "components/STONEWEG/Global/DashboardGlobal";

/*========= PUBLIC ROUTES =============*/
const publicRoutes = [
  { path: "/login", component: Login },
  { path: "/register", component: Register },
  { path: "/forgot-password", component: ForgotPassword },
];

/*========= PROTECTED ROUTES =============*/
const protectedRoutes = [
  // ========= AUTHENTICATION =========
  { path: "/logout", component: Logout },

  // ========= DASHBOARDS =========
  { path: "/dashboard", component: GlobalDashboard },
  { path: "/dmdashboard", component: DoctorManagementDashboard },
  { path: "/procurementdashboard", component: ProcurementDashboard },

  // ========= DOCTOR MANAGEMENT =========
  { path: "/doctors/list", component: DoctorDashboard },
  { path: "/patients/list", component: PatientTable },
  { path: "/prescriptions", component: PrescriptionList },
  { path: "/treatments", component: Treatments },
  { path: "/healthCenter", component: HealthCenters },
  { path: "/inventory", component: InventoryTable },
  { path: "/medicines", component: MedicinesList },
  { path: "/timeline", component: AppointmentTimelineList },
  { path: "/vaccinations", component: VaccinationList },
  { path: "/patient-treatment-details", component: PatientTreatmentsDetail }, // Assuming this is the route for PatientTreatmentDetailList
  { path: "/billable-activities", component: BillingList },
  // ====== PATIENT VIEW DATA ========
  { path: "/perfilPatientView", component: PatientView},
  { path: "/my-allergies", component: AllergiesTreatments },
  { path: "/my-immunizations", component: ImmunizationTreatments },
  { path: "/my-vitals", component: VitalsTreatments },
  { path: "/my-prescriptions", component: PatientPrescriptionTreatments },
  { path: "/my-electronic-prescriptions", component: ElectronicPrescriptionsTreatments },
  { path: "/my-appointments", component: AppointmentTreatment },
  { path: "/my-conditions", component: ConditionsTreatment },
  { path: "/my-medications", component: MedicineTreatment},
  { path: "/my-results", component: ResultTreatment},
  { path: "/my-orders", component: OrdersTreatment},
  { path: "/my-consents", component: ConsentTreatment},
  // ========= TOOLS =========
  { path: "/smarttranslator", component: SmartList },
  { path: "/diagnostic-assistant", component: DiagnosticAssistantList },
  { path: "/visualizer", component: InteractionVisualizer },
  { path: "/electronic-prescription", component: ElectronicPrescription },
  { path: "/symptom-assistant", component: SymptomAssistant },
  { path: "/digimevo", component: DigimevoPrescription},
  { path: "/company-process/list", component: CompanyProcessManage },
  { path: "/evaluacion-cognitiva", component:CogniEvaManage }, // evaluación cognitiva
  { path: "/dashboardGlobal", component: DashboardGlobal},
  

  // ========= ADMINISTRATION =========
  { path: "/treatmentTemplate", component: TreatmentsList },
  { path: "/treatmentTemplateAdd", component: Treatment},
  { path: "/laboratoryTemplates", component: LaboratoryTemplates},
  { path: "/laboratoryTemplateAdd", component: LaboratoryTemplateAdd}, 
  { path: "/catalog" , component: ProductView},
  { path: "/costumerPriceLists", component: CustomerPriceList},
  { path: "/supplierPriceLists", component: SupplierPriceList},
  
  // ========= COMMENTED/DISABLED =========
  // { path: "/client-form", component: ClientManagment },
];

// Exportamos también las rutas internas que manejará GlobalDashboard
export { publicRoutes, protectedRoutes };